<div class="main-container layout-no-chrome d-flex">
    <div class="h-100p overflow-y-scroll w-100">
        <div class="custom_container">
            <div class="search-container">
                <div class="top-actions">
                    <div class="top-actions-left">
                        <button class="back-button" (click)="onBackButtonClick()">
                            <i class="fas fa-arrow-left"></i>
                            Back
                        </button>
                        <div class="view-tabs" *ngIf="isOsintAiAnalysisEnabled">
                            <button type="button" class="view-tab" [class.active]="activeViewTab === 'results'" (click)="setViewTab('results')">
                                <i class="fas fa-list"></i>
                                Results
                            </button>
                            <button type="button" class="view-tab" [class.active]="activeViewTab === 'ai-analysis'" (click)="setViewTab('ai-analysis')" *ngIf="isOsintAiAnalysisEnabled">
                                <i class="fas fa-wand-magic-sparkles"></i>
                                AI OSINT Analysis
                            </button>
                        </div>
                    </div>
                    <div class="top-query" *ngIf="selectedSearchResult">
                        <span class="top-query-value">{{ selectedSearchResult?.searched_email }}</span>
                    </div>
                    <div class="top-actions-right" *ngIf="selectedSearchResult">
                        <div class="search-box">
                            <input class="search-input" type="text" placeholder="Search here" [(ngModel)]="searchTerm" (ngModelChange)="onSearchTermChange()" (input)="onSearchTermChange()" />
                        </div>
                        <div class="dropdown">
                            <button class="export-button dropdown-toggle" type="button" id="exportDropdown" data-bs-toggle="dropdown" aria-expanded="false">
                                <i class="fas fa-download"></i>
                                Export Report
                            </button>
                            <ul class="dropdown-menu" aria-labelledby="exportDropdown">
                                <!-- <li><a class="dropdown-item export-item" (click)="onExportOptionClick('pdf')">Export as PDF</a></li> -->
                                <li><a class="dropdown-item export-item" (click)="onPrintableOptionClick()">Export as PDF</a></li>
                                <!-- <li><a class="dropdown-item export-item" (click)="onExportOptionClick('docx')">Export as DOCX</a></li> -->
                            </ul>
                        </div>
                    </div>
                </div>

                <div class="text-light" *ngIf="noRecords">No Records Found</div>

                <div *ngIf="isLoadingResults" class="loading-container text-center my-3">
                    <div class="spinner-border text-primary" role="status"></div>
                    <p class="mt-2 text-main-color">Fetching results, please wait...</p>
                </div>

                <section class="result-status-cards" *ngIf="!isLoadingResults && selectedSearchResult && activeViewTab === 'results'" aria-label="Search result summary">
                    <button type="button" class="result-status-card is-found" (click)="openFoundDrillModal()">
                        <span class="result-status-accent" aria-hidden="true"></span>
                        <span class="result-status-icon" aria-hidden="true"><i class="bi bi-check-circle"></i></span>
                        <span class="result-status-count">{{ foundCount }}</span>
                        <span class="result-status-label">Found</span>
                        <i class="fas fa-chevron-right result-status-chevron" aria-hidden="true"></i>
                    </button>

                    <button type="button" class="result-status-card is-names" (click)="openNamesDrillModal()">
                        <span class="result-status-accent" aria-hidden="true"></span>
                        <span class="result-status-icon" aria-hidden="true"><i class="bi bi-person"></i></span>
                        <span class="result-status-count">{{ namesCount }}</span>
                        <span class="result-status-label">Names</span>
                        <i class="fas fa-chevron-right result-status-chevron" aria-hidden="true"></i>
                    </button>

                    <button type="button" class="result-status-card is-photos" (click)="openPhotosDrillModal()">
                        <span class="result-status-accent" aria-hidden="true"></span>
                        <span class="result-status-icon" aria-hidden="true"><i class="bi bi-image"></i></span>
                        <span class="result-status-count">{{ photosCount }}</span>
                        <span class="result-status-label">Photos</span>
                        <i class="fas fa-chevron-right result-status-chevron" aria-hidden="true"></i>
                    </button>

                    <button type="button" class="result-status-card is-emails" (click)="openEmailsDrillModal()">
                        <span class="result-status-accent" aria-hidden="true"></span>
                        <span class="result-status-icon" aria-hidden="true"><i class="bi bi-envelope"></i></span>
                        <span class="result-status-count">{{ emailsCount }}</span>
                        <span class="result-status-label">Emails</span>
                        <i class="fas fa-chevron-right result-status-chevron" aria-hidden="true"></i>
                    </button>

                    <button type="button" class="result-status-card is-email-hints" *ngIf="emailHintsCount" (click)="openEmailHintsDrillModal()">
                        <span class="result-status-accent" aria-hidden="true"></span>
                        <span class="result-status-icon" aria-hidden="true"><i class="bi bi-at"></i></span>
                        <span class="result-status-count">{{ emailHintsCount }}</span>
                        <span class="result-status-label">Email Hints</span>
                        <i class="fas fa-chevron-right result-status-chevron" aria-hidden="true"></i>
                    </button>
                </section>

                <div class="results-grid" *ngIf="!isLoadingResults && selectedSearchResult && activeViewTab === 'results'">
                    <section class="right-content">
                        <div class="platform-filter-bar" *ngIf="!isLoadingResults && selectedSearchResult && activeViewTab === 'results' && searchResultDetailsFiltered.length">
                            <div class="platform-filter-tabs" role="tablist" aria-label="Platform categories">
                                <button type="button" class="platform-filter-tab platform-filter-top" [class.muted]="isAtTop" (click)="jumpToTop()" aria-label="Scroll to top">
                                    <i class="fas fa-arrow-up" aria-hidden="true"></i>
                                    Top
                                </button>
                                <span class="platform-filter-sep" aria-hidden="true"></span>
                                <button type="button" class="platform-filter-tab" *ngFor="let category of platformCategoryTabs" [class.active]="selectedPlatformCategory === category" (click)="selectPlatformCategory(category)">
                                    {{ category }}
                                </button>
                                <button type="button" class="platform-filter-tab" [class.active]="showFoundOnly" (click)="toggleFoundOnly()">
                                    <i class="fas fa-filter" aria-hidden="true"></i>
                                    Found only
                                </button>
                                <button type="button" class="platform-filter-tab" *ngIf="showGoogleResults" (click)="jumpToGoogleResults()" aria-label="Jump to Google Results">
                                    <i class="fas fa-search" aria-hidden="true"></i>
                                    Google Results
                                </button>
                            </div>
                        </div>

                        <div id="source-results" class="source-card-grid abacus-card-grid" [class.two-card-layout]="usesTwoColumnSourceCards" [class.multi-card-layout]="displayedSearchResultDetails.length > 2">
                            <article class="result-card source-card abacus-card" *ngFor="let searchResultDetailFiltered of displayedSearchResultDetails; let i = index" [class.is-tc-names]="utilsService.isTcNamesPlatform(searchResultDetailFiltered)" [class.data-dense]="isDataDenseSourceCard(searchResultDetailFiltered)" [class.is-not-found]="searchResultDetailFiltered.notFound" [ngStyle]="getPlatformThemeStyle(searchResultDetailFiltered.platform)" [attr.id]="getPlatformSectionId(searchResultDetailFiltered.platform)">
                                <header class="abacus-card-header">
                                    <div class="abacus-card-identity">
                                        <div class="abacus-icon-wrap">
                                            <img [src]="searchResultDetailFiltered.icon" [alt]="searchResultDetailFiltered.platform" class="abacus-platform-icon" (error)="onIconError($event)" />
                                        </div>
                                        <div class="abacus-title-wrap">
                                            <h3 class="abacus-platform-name">{{ searchResultDetailFiltered.platform }}</h3>
                                            <p class="abacus-platform-category">{{ resolvePlatformCategory(searchResultDetailFiltered) }}</p>
                                        </div>
                                    </div>
                                    <div class="abacus-card-actions">
                                        <span class="abacus-status-badge" [class.is-found]="!searchResultDetailFiltered.notFound" [class.is-missing]="searchResultDetailFiltered.notFound" [attr.title]="searchResultDetailFiltered.notFound ? 'Not found' : 'Found'" [attr.aria-label]="searchResultDetailFiltered.notFound ? 'Account not found' : 'Account found'">
                                            <i class="bi" [ngClass]="searchResultDetailFiltered.notFound ? 'bi-x-circle' : 'bi-check-circle'" aria-hidden="true"></i>
                                        </span>
                                        <a *ngIf="getProfileLinkDetail(searchResultDetailFiltered) as headerProfileLink" class="abacus-header-external-link" [href]="utilsService.toLink(headerProfileLink.value)" target="_blank" rel="noopener noreferrer" [attr.title]="getProfileLinkTitle(searchResultDetailFiltered)" [attr.aria-label]="getProfileLinkTitle(searchResultDetailFiltered)">
                                            <i class="fas fa-external-link-alt" aria-hidden="true"></i>
                                        </a>
                                    </div>
                                </header>

                                <p class="abacus-not-found-message" *ngIf="searchResultDetailFiltered.notFound">Not found</p>

                                <div class="abacus-card-body" *ngIf="!searchResultDetailFiltered.notFound">
                                    <div class="abacus-field abacus-pictures-field" *ngIf="getPlatformImageForCard(searchResultDetailFiltered) as platformImage">
                                        <span class="abacus-field-label">Pictures</span>
                                        <div class="abacus-picture-frame-wrap">
                                            <button type="button" class="abacus-picture-frame clickable" [attr.aria-label]="'Open ' + platformImage.name + ' photo'" (click)="openPlatformImage(searchResultDetailFiltered.platform)">
                                                <img [src]="platformImage.src" [alt]="platformImage.name" class="abacus-picture" referrerpolicy="no-referrer" (error)="onPictureError($event)" />
                                            </button>
                                            <button *ngIf="canStartImageSearch(platformImage)" type="button" class="image-search-trigger" (click)="startImageSearchFromSrc(platformImage, $event)" title="Image Search" aria-label="Image Search">
                                                <i class="fas fa-magnifying-glass" aria-hidden="true"></i>
                                            </button>
                                        </div>
                                    </div>

                                    <p class="abacus-description" *ngIf="getCardDescription(searchResultDetailFiltered) as description">{{ description }}</p>

                                    <div class="abacus-field" *ngFor="let detail of getCardBodyDetails(searchResultDetailFiltered)">
                                        <span class="abacus-field-label">{{ detail.label }}</span>
                                        <div class="abacus-field-value-row">
                                            <ng-container [ngSwitch]="detail.type">
                                                <a *ngSwitchCase="'link'" [href]="utilsService.toLink(detail.value)" target="_blank" rel="noopener noreferrer" class="abacus-field-value abacus-inline-link">{{ detail.value }}</a>
                                                <span *ngSwitchCase="'datetime'" class="abacus-field-value">{{ utilsService.formatDateTime(detail.value) }}</span>
                                                <span *ngSwitchCase="'date'" class="abacus-field-value">{{ formatDateValue(detail.value) }}</span>
                                                <span *ngSwitchCase="'boolean'" class="abacus-field-value">{{ detail.value ? 'Yes' : 'No' }}</span>
                                                <span *ngSwitchCase="'number'" class="abacus-field-value">{{ detail.value }}</span>
                                                <ng-container *ngSwitchCase="'list'">
                                                    <span *ngIf="isEmptyValue(detail.value)" class="abacus-field-value">N/A</span>
                                                    <ng-container *ngIf="!isEmptyValue(detail.value) && getDisplayListItems(detail) as listItems">
                                                        <span *ngIf="listItems.length <= 1" class="abacus-field-value abacus-list-cards">
                                                            <span class="abacus-list-card">{{ listItems[0] }}</span>
                                                        </span>
                                                        <ul *ngIf="listItems.length > 1" class="abacus-field-value abacus-field-list" [class.abacus-list-cards]="!utilsService.isDateTimeBulletList(detail) && !utilsService.isPlainStringList(detail)" [class.abacus-address-bullets]="utilsService.usesDiscBullets(detail)" [class.abacus-datetime-bullets]="utilsService.isDateTimeBulletList(detail)" [class.abacus-plain-bullets]="utilsService.isPlainStringList(detail)">
                                                            <li *ngFor="let item of listItems">
                                                                <span *ngIf="utilsService.isDateTimeBulletList(detail) || utilsService.isPlainStringList(detail); else emailListCard">{{ item }}</span>
                                                                <ng-template #emailListCard><span class="abacus-list-card">{{ item }}</span></ng-template>
                                                                <mat-icon *ngIf="shouldShowSearchIconForItem(detail, item)" class="search-icon" (click)="navigateToSearch(getOsintSearchType(detail), item)" title="Search for {{item}}">search</mat-icon>
                                                            </li>
                                                        </ul>
                                                    </ng-container>
                                                </ng-container>
                                                <span *ngSwitchCase="'object'" class="abacus-field-value">{{ isEmptyValue(detail.value) ? '{}' : formatObjectValue(detail.value) }}</span>
                                                <span *ngSwitchCase="'dict'" class="abacus-field-value">{{ isEmptyValue(detail.value) ? 'N/A' : formatObjectValue(detail.value) }}</span>
                                                <span *ngSwitchDefault class="abacus-field-value" [class.is-active]="isActiveStatusValue(detail)">{{ utilsService.formatDisplayValue(detail.value) }}</span>
                                            </ng-container>
                                            <mat-icon *ngIf="shouldShowRowSearchIcon(detail)" class="search-icon" (click)="navigateToSearch(getOsintSearchType(detail), detail.value)" title="Search for {{detail.value}}">search</mat-icon>
                                        </div>
                                    </div>
                                </div>

                                <a *ngIf="getProfileLinkDetail(searchResultDetailFiltered) as profileLink" class="abacus-external-link" [href]="utilsService.toLink(profileLink.value)" target="_blank" rel="noopener noreferrer" [attr.title]="getProfileLinkTitle(searchResultDetailFiltered)" [attr.aria-label]="getProfileLinkTitle(searchResultDetailFiltered)">
                                    <i class="fas fa-external-link-alt" aria-hidden="true"></i>
                                    <span>{{ getLinkDisplayText(profileLink.value) }}</span>
                                </a>
                            </article>
                        </div>

                        <div id="google-results" class="google-results-section" *ngIf="showGoogleResults">
                            <div class="card-header-green google-header">
                                <svg class="google-icon-svg" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="20" height="20" aria-hidden="true">
                                    <path fill="#4285F4" d="M22.56 12.25c0-.78-.07-1.53-.2-2.25H12v4.26h5.92c-.26 1.37-1.04 2.53-2.21 3.31v2.77h3.57c2.08-1.92 3.28-4.74 3.28-8.09z" />
                                    <path fill="#34A853" d="M12 23c2.97 0 5.46-.98 7.28-2.66l-3.57-2.77c-.98.66-2.23 1.06-3.71 1.06-2.86 0-5.29-1.93-6.16-4.53H2.18v2.84C3.99 20.53 7.7 23 12 23z" />
                                    <path fill="#FBBC05" d="M5.84 14.09c-.22-.66-.35-1.36-.35-2.09s.13-1.43.35-2.09V7.07H2.18C1.43 8.55 1 10.22 1 12s.43 3.45 1.18 4.93l2.85-2.22.81-.62z" />
                                    <path fill="#EA4335" d="M12 5.38c1.62 0 3.06.56 4.21 1.64l3.15-3.15C17.45 2.09 14.97 1 12 1 7.7 1 3.99 3.47 2.18 7.07l3.66 2.84c.87-2.6 3.3-4.53 6.16-4.53z" />
                                </svg>
                                <span>Google Results</span>
                                <a *ngIf="googleSearchHref" class="google-open-link" [href]="googleSearchHref" target="_blank" rel="noopener noreferrer">Open in Google</a>
                            </div>
                            <div class="google-query-selector" *ngIf="googleQueryVariants.length > 1" role="tablist" aria-label="Google search query variants">
                                <button type="button" class="google-query-chip" *ngFor="let variant of googleQueryVariants" [class.active]="selectedGoogleQueryId === variant.id" [attr.title]="variant.query" [attr.aria-selected]="selectedGoogleQueryId === variant.id" (click)="selectGoogleQuery(variant)">
                                    {{ variant.label }}
                                </button>
                            </div>
                            <div class="google-results-container">
                                <iframe *ngIf="googleResultsUrl" class="google-results-iframe" [src]="googleResultsUrl" title="Google Results" referrerpolicy="no-referrer-when-downgrade"></iframe>
                            </div>
                        </div>

                        <div class="notes-section">
                            <div class="notes-header">Add Notes</div>
                            <div class="notes-content">
                                <textarea class="note-input" maxlength="300" placeholder="Notes" [(ngModel)]="notes"></textarea>
                                <div class="notes-footer">
                                    <span class="character-count">{{ notes.length }}/300</span>
                                    <button class="update-button" (click)="onUpdateNotesButtonClick()">Update Notes</button>
                                </div>
                            </div>
                        </div>
                    </section>
                </div>

                <div class="ai-analysis-view" *ngIf="isOsintAiAnalysisEnabled && !isLoadingResults && selectedSearchResult && activeViewTab === 'ai-analysis'">
                    <app-osint-ai-analysis [searchId]="searchId" type="email" [queryValue]="selectedSearchResult?.searched_email || ''" [hasSourceData]="searchResultDetailsFiltered.length > 0 || searchResultImages.length > 0 || aggregatedNames.length > 0 || aggregatedEmails.length > 0 || aggregatedEmailHints.length > 0"></app-osint-ai-analysis>
                </div>
            </div>
        </div>
    </div>
</div>

<div class="image-modal-overlay" *ngIf="selectedImage" (click)="closeImageModal()">
    <div class="image-modal-content" (click)="$event.stopPropagation()">
        <button class="image-modal-close" (click)="closeImageModal()" aria-label="Close modal">
            <i class="fas fa-times"></i>
        </button>
        <button *ngIf="canStartImageSearch(selectedImage)" type="button" class="image-search-trigger is-modal" (click)="startImageSearchFromSrc(selectedImage, $event)" title="Image Search" aria-label="Image Search">
            <i class="fas fa-magnifying-glass" aria-hidden="true"></i>
            <span>Image Search</span>
        </button>
        <img [src]="selectedImage.src" [alt]="selectedImage.name" class="image-modal-img" />
    </div>
</div>

<div class="found-drill-overlay" *ngIf="showFoundDrillModal" (click)="closeFoundDrillModal()">
    <div class="found-drill-panel" (click)="$event.stopPropagation()" role="dialog" aria-modal="true" aria-labelledby="found-drill-title">
        <header class="found-drill-header">
            <div class="found-drill-heading">
                <div class="found-drill-title-row">
                    <h2 id="found-drill-title">Found</h2>
                    <span class="found-drill-count">{{ foundCount }} platforms</span>
                </div>
                <p class="found-drill-subtitle">A profile is live on each of these under this email.</p>
            </div>
            <div class="found-drill-actions">
                <div class="found-drill-search">
                    <i class="fas fa-search" aria-hidden="true"></i>
                    <input type="text" placeholder="Search platforms" [(ngModel)]="foundPlatformSearchTerm" aria-label="Search found platforms" />
                </div>
                <button type="button" class="found-drill-close" (click)="closeFoundDrillModal()" aria-label="Close found platforms">
                    <i class="fas fa-times"></i>
                </button>
            </div>
        </header>

        <div class="found-drill-grid" *ngIf="filteredFoundPlatforms.length; else noFoundMatches">
            <article class="found-drill-card" *ngFor="let platform of filteredFoundPlatforms" (click)="onFoundPlatformClick(platform)" (keydown.enter)="onFoundPlatformClick(platform)" (keydown.space)="$event.preventDefault(); onFoundPlatformClick(platform)" tabindex="0" role="button" [attr.aria-label]="'Open ' + getDrillPlatformName(platform) + ' profile'">
                <ng-container *ngIf="getPlatformImageForCard(platform) as platformImage; else foundDrillLogo">
                    <div class="found-drill-thumb-wrap">
                        <img class="found-drill-thumb" [src]="platformImage.src" [alt]="getDrillPlatformName(platform)" referrerpolicy="no-referrer" (error)="onPictureError($event)" />
                        <span class="found-drill-badge">
                            <img [src]="getDrillPlatformIcon(platform)" [alt]="getDrillPlatformName(platform)" (error)="onIconError($event)" />
                        </span>
                    </div>
                </ng-container>
                <ng-template #foundDrillLogo>
                    <div class="found-drill-icon-wrap">
                        <img class="found-drill-icon" [src]="getDrillPlatformIcon(platform)" [alt]="getDrillPlatformName(platform)" (error)="onIconError($event)" />
                    </div>
                </ng-template>
                <div class="found-drill-card-text">
                    <span class="found-drill-platform">{{ getDrillPlatformName(platform) }}</span>
                    <span class="found-drill-meta" *ngIf="getDrillPlatformUrlText(platform) as profileUrl">{{ profileUrl }}</span>
                </div>
                <i class="fas fa-chevron-right found-drill-chevron" aria-hidden="true"></i>
            </article>
        </div>

        <ng-template #noFoundMatches>
            <div class="found-drill-empty">No platforms match your search.</div>
        </ng-template>
    </div>
</div>

<div class="found-drill-overlay" *ngIf="showNamesDrillModal" (click)="closeNamesDrillModal()">
    <div class="found-drill-panel" (click)="$event.stopPropagation()" role="dialog" aria-modal="true" aria-labelledby="names-drill-title">
        <header class="found-drill-header">
            <div class="found-drill-heading">
                <div class="found-drill-title-row">
                    <h2 id="names-drill-title">Names</h2>
                    <span class="found-drill-count">{{ namesCount }} confirmed</span>
                </div>
                <p class="found-drill-subtitle">These names were recovered under this email.</p>
            </div>
            <div class="found-drill-actions">
                <div class="found-drill-search">
                    <i class="fas fa-search" aria-hidden="true"></i>
                    <input type="text" placeholder="Search names" [(ngModel)]="namesSearchTerm" aria-label="Search names" />
                </div>
                <button type="button" class="found-drill-close" (click)="closeNamesDrillModal()" aria-label="Close names">
                    <i class="fas fa-times"></i>
                </button>
            </div>
        </header>

        <div class="found-drill-grid names-drill-grid" *ngIf="filteredNameDrillEntries.length; else noNameMatches">
            <article class="found-drill-card" *ngFor="let entry of filteredNameDrillEntries" (click)="onNameDrillClick(entry.platforms)" (keydown.enter)="onNameDrillClick(entry.platforms)" (keydown.space)="$event.preventDefault(); onNameDrillClick(entry.platforms)" tabindex="0" role="button" [attr.aria-label]="'Open sources for ' + entry.name">
                <div class="found-drill-thumb-wrap">
                    <img class="found-drill-thumb" [src]="getNameDrillThumb(entry.platforms)" [alt]="entry.name" referrerpolicy="no-referrer" (error)="onPictureError($event)" />
                    <span class="found-drill-badge">
                        <img [src]="getNameDrillPlatformIcon(entry.platforms)" [alt]="getNameDrillPrimaryPlatform(entry.platforms)?.platform || 'platform'" (error)="onIconError($event)" />
                    </span>
                </div>
                <div class="found-drill-card-text">
                    <span class="found-drill-platform" [attr.title]="entry.name">{{ entry.name }}</span>
                    <span class="found-drill-meta">{{ getNameDrillSubtitle(entry.platforms) }}</span>
                </div>
                <button type="button" class="identity-copy-btn" (click)="$event.stopPropagation(); copySummaryValue(entry.name)" [attr.aria-label]="'Copy ' + entry.name" title="Copy">
                    <i class="far fa-copy" aria-hidden="true"></i>
                </button>
            </article>
        </div>

        <ng-template #noNameMatches>
            <div class="found-drill-empty">No names match your search.</div>
        </ng-template>
    </div>
</div>

<div class="found-drill-overlay" *ngIf="showPhotosDrillModal" (click)="closePhotosDrillModal()">
    <div class="found-drill-panel photos-drill-panel" (click)="$event.stopPropagation()" role="dialog" aria-modal="true" aria-labelledby="photos-drill-title">
        <header class="found-drill-header">
            <div class="found-drill-heading">
                <div class="found-drill-title-row">
                    <h2 id="photos-drill-title">Photos</h2>
                    <span class="found-drill-count">{{ photosCount }} recovered</span>
                </div>
                <p class="found-drill-subtitle">All recovered photos for this email.</p>
            </div>
            <div class="found-drill-actions">
                <button type="button" class="found-drill-close" (click)="closePhotosDrillModal()" aria-label="Close photos">
                    <i class="fas fa-times"></i>
                </button>
            </div>
        </header>

        <div class="photos-drill-grid" *ngIf="searchResultImages.length; else noPhotoMatches">
            <div class="photos-drill-item" *ngFor="let image of searchResultImages; let i = index" [class.is-portrait]="getPhotoDrillShape(i) === 'portrait'" [class.is-landscape]="getPhotoDrillShape(i) === 'landscape'" [class.is-square]="getPhotoDrillShape(i) === 'square'">
                <button type="button" class="photos-drill-open" (click)="onPhotoDrillClick(i)" [attr.aria-label]="'Open photo from ' + image.platform">
                    <img [src]="image.src" [alt]="image.name || image.platform" (load)="onPhotoDrillImageLoad($event, i)" (error)="onIconError($event)" />
                    <span class="photos-drill-platform" *ngIf="image.platform">{{ image.platform }}</span>
                </button>
                <button *ngIf="canStartImageSearch(image)" type="button" class="image-search-trigger" (click)="startImageSearchFromSrc(image, $event)" title="Image Search" aria-label="Image Search">
                    <i class="fas fa-magnifying-glass" aria-hidden="true"></i>
                </button>
            </div>
        </div>

        <ng-template #noPhotoMatches>
            <div class="found-drill-empty">No photos available.</div>
        </ng-template>
    </div>
</div>

<div class="found-drill-overlay" *ngIf="showEmailsDrillModal" (click)="closeEmailsDrillModal()">
    <div class="found-drill-panel" (click)="$event.stopPropagation()" role="dialog" aria-modal="true" aria-labelledby="emails-drill-title">
        <header class="found-drill-header">
            <div class="found-drill-heading">
                <div class="found-drill-title-row">
                    <h2 id="emails-drill-title">Email addresses</h2>
                    <span class="found-drill-count">{{ emailsCount }} confirmed</span>
                </div>
                <p class="found-drill-subtitle">These email addresses were recovered under this email.</p>
            </div>
            <div class="found-drill-actions">
                <div class="found-drill-search">
                    <i class="fas fa-search" aria-hidden="true"></i>
                    <input type="text" placeholder="Search emails" [(ngModel)]="emailsSearchTerm" aria-label="Search emails" />
                </div>
                <button type="button" class="found-drill-close" (click)="closeEmailsDrillModal()" aria-label="Close emails">
                    <i class="fas fa-times"></i>
                </button>
            </div>
        </header>

        <div class="found-drill-grid names-drill-grid" *ngIf="filteredEmails.length; else noEmailMatches">
            <article class="found-drill-card is-static" *ngFor="let email of filteredEmails">
                <div class="emails-drill-icon" aria-hidden="true"><i class="fas fa-envelope"></i></div>
                <div class="found-drill-card-text">
                    <span class="found-drill-platform" [attr.title]="email">{{ email }}</span>
                </div>
                <mat-icon *ngIf="isValidSearchValue(email)" class="search-icon" (click)="navigateToSearch('email', email)" title="Search for {{email}}">search</mat-icon>
                <button type="button" class="identity-copy-btn" (click)="copySummaryValue(email)" [attr.aria-label]="'Copy ' + email" title="Copy">
                    <i class="far fa-copy" aria-hidden="true"></i>
                </button>
            </article>
        </div>

        <ng-template #noEmailMatches>
            <div class="found-drill-empty">No emails match your search.</div>
        </ng-template>
    </div>
</div>

<div class="found-drill-overlay" *ngIf="showEmailHintsDrillModal" (click)="closeEmailHintsDrillModal()">
    <div class="found-drill-panel" (click)="$event.stopPropagation()" role="dialog" aria-modal="true" aria-labelledby="email-hints-drill-title">
        <header class="found-drill-header">
            <div class="found-drill-heading">
                <div class="found-drill-title-row">
                    <h2 id="email-hints-drill-title">Email Hints</h2>
                    <span class="found-drill-count">{{ emailHintsCount }} confirmed</span>
                </div>
                <p class="found-drill-subtitle">These email hints were recovered under this email.</p>
            </div>
            <div class="found-drill-actions">
                <div class="found-drill-search is-no-icon">
                    <input type="text" placeholder="Search email hints" [(ngModel)]="emailHintsSearchTerm" aria-label="Search email hints" />
                </div>
                <button type="button" class="found-drill-close" (click)="closeEmailHintsDrillModal()" aria-label="Close email hints">
                    <i class="fas fa-times"></i>
                </button>
            </div>
        </header>

        <div class="found-drill-grid names-drill-grid" *ngIf="filteredEmailHints.length; else noEmailHintMatches">
            <article class="found-drill-card is-static" *ngFor="let hint of filteredEmailHints">
                <div class="email-hints-drill-icon" aria-hidden="true"><i class="fas fa-at"></i></div>
                <div class="found-drill-card-text">
                    <span class="found-drill-platform" [attr.title]="hint">{{ hint }}</span>
                </div>
                <button type="button" class="identity-copy-btn" (click)="copySummaryValue(hint)" [attr.aria-label]="'Copy ' + hint" title="Copy">
                    <i class="far fa-copy" aria-hidden="true"></i>
                </button>
            </article>
        </div>

        <ng-template #noEmailHintMatches>
            <div class="found-drill-empty">No email hints match your search.</div>
        </ng-template>
    </div>
</div>